if (!customElements.get('product-card-gallery')) {
  customElements.define(
    'product-card-gallery',
    class ProductCardGallery extends HTMLElement {
      connectedCallback() {
        // Init here (not constructor): after Ajax facet renders, the constructor
        // runs before children exist, so querySelector would return an empty set.
        if (this.initialized) return;
        this.initialized = true;

        this.images = Array.from(this.querySelectorAll('[data-gallery-image]'));
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
        this.prevButton = this.querySelector('[data-gallery-prev]');
        this.nextButton = this.querySelector('[data-gallery-next]');

        const activeIdx = this.images.findIndex((image) => image.classList.contains('is-active'));
        this.activeIndex = activeIdx >= 0 ? activeIdx : 0;

        this.imageBox =
          this.querySelector('.card__inner') ||
          this.querySelector('[class*="__image-wrapper"]') ||
          this.querySelector('.card__media');

        // Touches often land on the full-card link overlay outside .card__inner.
        this.surface =
          this.closest('.card-wrapper') ||
          this.closest('li') ||
          this.parentElement ||
          this;

        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchActive = false;
        this.lockAxis = null;
        this.swiped = false;

        if (this.imageBox) {
          this.imageBox.style.touchAction = 'pan-y';
        }

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onClickAfterSwipe = this.onClickAfterSwipe.bind(this);

        this.surface.addEventListener('touchstart', this.onTouchStart, { passive: true });
        // Non-passive so we can preventDefault once horizontal swipe is locked
        // (keeps vertical page scroll free until then).
        this.surface.addEventListener('touchmove', this.onTouchMove, { passive: false });
        this.surface.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.surface.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
        this.surface.addEventListener('click', this.onClickAfterSwipe, true);

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.onNextClick.bind(this));
        }

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.show(index);
          });
        });
      }

      onPrevClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.show(this.activeIndex - 1);
        event.currentTarget.blur();
      }

      onNextClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.show(this.activeIndex + 1);
        event.currentTarget.blur();
      }

      isOnImage(touch) {
        if (!this.imageBox) return true;
        const box = this.imageBox.getBoundingClientRect();
        return (
          touch.clientX >= box.left &&
          touch.clientX <= box.right &&
          touch.clientY >= box.top &&
          touch.clientY <= box.bottom
        );
      }

      onTouchStart(event) {
        if (event.touches.length !== 1 || this.images.length < 2) return;

        const touch = event.touches[0];
        this.swiped = false;
        this.lockAxis = null;
        this.touchActive = false;

        if (event.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-dot]')) {
          return;
        }
        if (!this.isOnImage(touch)) return;

        this.touchActive = true;
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      onTouchMove(event) {
        if (!this.touchActive || this.swiped) return;

        const touch = event.touches[0];
        const dx = touch.clientX - this.touchStartX;
        const dy = touch.clientY - this.touchStartY;

        if (!this.lockAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          this.lockAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }

        if (this.lockAxis === 'y') {
          // Vertical intent — release so the page can scroll normally.
          this.touchActive = false;
          return;
        }

        // Horizontal swipe locked: block scroll / browser back-swipe side effects.
        event.preventDefault();

        if (Math.abs(dx) < 40) return;

        this.show(this.activeIndex + (dx < 0 ? 1 : -1));
        this.swiped = true;
        this.touchActive = false;
      }

      onTouchEnd() {
        this.touchActive = false;
        this.lockAxis = null;
      }

      onClickAfterSwipe(event) {
        if (!this.swiped) return;
        event.preventDefault();
        event.stopPropagation();
        this.swiped = false;
      }

      show(index) {
        const total = this.images.length;
        if (total === 0) return;
        this.activeIndex = (index + total) % total;

        this.images.forEach((image, i) => {
          image.classList.toggle('is-active', i === this.activeIndex);
        });

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.activeIndex);
        });
      }
    }
  );
}
